<template>
  <custom-draw width="1080px" :title="model.title" :visible="visible" v-on="$listeners" :appendToBody="true">
    <div class="draw-body">
      <div class="aside">
        <h1>{{ $t('crm_step_manage_falsify_dialog.ji_ben_xin_xi') }}{{ goodsInfo.goodsSkuOwner }}</h1>
        <ul>
          <li>
            <div>{{ $t('crm_step_manage_falsify_dialog.chan_pin_xing_hao') }}</div>
            <div>{{ goodsInfo.productCode }}</div>
          </li>
          <li>
            <div>{{ $t('crm_step_manage_falsify_dialog.zlzqdw') }}</div>
            <div>
              {{ getDicValue('rental_term_unit', goodsInfo.rentalTermUnit) }}
            </div>
          </li>
          <li>
            <div>{{ $t('crm_step_manage_falsify_dialog.zu_lin_shi_chang') }}</div>
            <div>{{ goodsInfo.rentalTermMin }} - {{ goodsInfo.rentalTermMax }}</div>
          </li>
          <li>
            <div>{{ $t('crm_step_manage_falsify_dialog.bi_zhong') }}</div>
            <div>{{ goodsInfo.currencyUnit }}</div>
          </li>
          <li>
            <div>{{ $t('crm_step_manage_falsify_dialog.zhi_fu_zhou_qi') }}</div>
            <div>
              {{ getDicValue('crm_payment_period', goodsInfo.paymentPeriod) }}
            </div>
          </li>
          <li>
            <div>{{ $t('crm_step_manage_falsify_dialog.zhi_fu_jie_dian') }}</div>
            <div>
              {{ getDicValue('payment_node', goodsInfo.paymentNode) }}
            </div>
          </li>

          <li>
            <div>{{ $t('crm_step_manage_falsify_dialog.she_bei_lei_xing') }}</div>
            <div>
              {{ getDicValue('dms_device_biz_type', goodsInfo.deviceBizType) }}
            </div>
          </li>
          <li>
            <div>{{ $t('crm_step_manage_falsify_dialog.she_bei_ya_jin') }}</div>
            <div>{{ goodsInfo.depositFee }}</div>
          </li>
          <li>
            <div>{{ $t('crm_step_manage_falsify_dialog.zu_jin') }}</div>
            <div>{{ goodsInfo.unitPrice }}</div>
          </li>
        </ul>
      </div>
      <div class="draw-section">
        <div class="item-title">{{ $t('crm_step_manage_falsify_dialog.wei_yue_tiao_kuan') }}</div>
        <custom-tab :list="tabList" v-model="tab" @changeBefore="changeTab"></custom-tab>
        <div :key="tab">
          <el-form ref="form" style="padding: 16px" v-if="model.type !== 'watch'">
            <el-form-item style="float: right; margin-left: 12px">
              <!-- <el-button type="primary" size="small" :disabled="!breakAction" @click="copyCurrent()">{{ $t('p_contractleaseAdd_tong_bu') }}</el-button> -->
              <el-button type="warning" size="small" @click="onClear()">{{ $t('Common.com_clear') }}</el-button>
            </el-form-item>
            <!-- <el-form-item style="float: right;">
              <custom-select style="width: 180px" v-model="breakAction" code="rms_sku_break_action" :props="{ label: 'name', value: 'code' }" :dataFilter="dataFilter" :placeholder="i18n.com_please_select"></custom-select>
            </el-form-item> -->
          </el-form>
          <!-- 逾期费 -->
          <div class="sub-title" style="margin-top: 18px">{{ $t('crm_step_manage_falsify_dialog.yu_qi_fei') }}</div>
          <el-table :data="form.overdueList" style="width: 100%" :size="allTableSize">
            <el-table-column :label="$t('crm_step_manage_falsify_dialog.yu_qi_tian_shu')" width="160">
              <template slot-scope="scope">
                <el-input :disabled="model.type === 'watch'" type="number" :min="0" v-model="scope.row.triggerDays" style="width: 146px"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('crm_step_manage_falsify_dialog.jin_e')" width="260">
              <template slot-scope="scope">
                <custom-select
                  :disabled="model.type === 'watch'"
                  style="display: inline-block; width: 100px; margin-right: 2px"
                  v-model="scope.row.feeMode"
                  code="rms_sku_break_fee_mode"
                  :isDefault="true"
                  :clearable="false"
                  valueType="number"
                ></custom-select>
                <el-input :disabled="model.type === 'watch'" type="number" :min="0" v-model="scope.row.feeValue" :placeholder="$t('Common.com_please_input')" style="width: calc(100% - 102px)"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('Common.com_remark')">
              <template slot-scope="scope">
                <el-input :disabled="model.type === 'watch'" v-model="scope.row.overdueDesc" style="width: 100%"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('Common.com_handle')" width="90px" v-if="model.type !== 'watch'">
              <template slot-scope="scope">
                <el-button v-if="scope.$index == 0" type="primary" @click="addSymbol('overdueList')">
                  <!-- <i class="icon icon-add"></i> -->
                  {{ $t('Common.com_added') }}
                </el-button>
                <el-button v-else type="warning" @click="delSymbol('overdueList', scope.$index)">
                  <!-- <i class="icon icon-shanchu"></i> -->
                  {{ $t('Common.com_delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 长租改短租 -->
          <div class="sub-title" style="margin-top: 18px">{{ $t('crm_step_manage_falsify_dialog.chang_zu_gai_duan_zu') }}</div>
          <el-table :size="allTableSize" :data="form.shortTermRentalList" style="width: 100%">
            <el-table-column :label="$t('crm_step_manage_falsify_dialog.yue_shu')" width="160">
              <template slot-scope="scope">
                <el-input
                  :disabled="model.type === 'watch'"
                  type="number"
                  :min="1"
                  :max="`${Number.parseInt(scope.row.breakTermMax || goodsInfo.rentalTermMax, 10) - 1}`"
                  v-model="scope.row.breakTermMin"
                  style="width: 64px"
                  @blur="numberBlur(scope.row, 1, Number.parseInt(scope.row.breakTermMax || goodsInfo.rentalTermMax, 10) - 1, 'breakTermMin')"
                ></el-input>
                <span style="display: inline-block; padding: 3px 6px 0">-</span>
                <el-input
                  :disabled="model.type === 'watch'"
                  type="number"
                  :min="`${Number.parseInt(scope.row.breakTermMin || 0, 10) + 1}`"
                  :max="`${goodsInfo.rentalTermMax}`"
                  v-model="scope.row.breakTermMax"
                  style="width: 64px"
                  @blur="numberBlur(scope.row, Number.parseInt(scope.row.breakTermMin || 0, 10) + 1, goodsInfo.rentalTermMax, 'breakTermMax')"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('crm_step_manage_falsify_dialog.jin_e')" width="260">
              <template slot-scope="scope">
                <custom-select
                  :disabled="model.type === 'watch'"
                  style="display: inline-block; width: 100px; margin-right: 2px"
                  v-model="scope.row.feeMode"
                  code="rms_sku_break_fee_mode"
                  :clearable="false"
                ></custom-select>
                <el-input
                  :disabled="model.type === 'watch'"
                  type="number"
                  :min="0"
                  :max="goodsInfo.rentalTermMax"
                  v-model="scope.row.feeValue"
                  :placeholder="$t('Common.com_please_input')"
                  style="width: calc(100% - 102px)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('Common.com_remark')">
              <template slot-scope="scope">
                <el-input :disabled="model.type === 'watch'" v-model="scope.row.breakDesc" style="width: 100%"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('Common.com_handle')" width="90px" v-if="model.type !== 'watch'">
              <template slot-scope="scope">
                <el-button v-if="scope.$index == 0" type="primary" @click="addSymbol('shortTermRentalList')">
                  <!-- <i class="icon icon-add"></i> -->
                  {{ $t('Common.com_added') }}
                </el-button>
                <el-button v-else type="warning" @click="delSymbol('shortTermRentalList', scope.$index)">
                  <!-- <i class="icon icon-shanchu"></i> -->
                  {{ $t('Common.com_delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 期内违约 -->
          <div class="sub-title" style="margin-top: 18px">{{ $t('crm_step_manage_falsify_dialog.qi_nei_wei_yue') }}</div>
          <el-table :size="allTableSize" :data="form.breakDuringPeriodList" style="width: 100%">
            <el-table-column :label="$t('crm_step_manage_falsify_dialog.yue_shu')" width="160">
              <template slot-scope="scope">
                <el-input
                  :disabled="model.type === 'watch'"
                  type="number"
                  :min="1"
                  :max="`${Number.parseInt(scope.row.breakTermMax || goodsInfo.rentalTermMax, 10) - 1}`"
                  v-model="scope.row.breakTermMin"
                  style="width: 64px"
                  @blur="numberBlur(scope.row, 1, Number.parseInt(scope.row.breakTermMax || goodsInfo.rentalTermMax, 10) - 1, 'breakTermMin')"
                ></el-input>
                <span style="display: inline-block; padding: 3px 6px 0">-</span>
                <el-input
                  :disabled="model.type === 'watch'"
                  type="number"
                  :min="`${Number.parseInt(scope.row.breakTermMin || 0, 10) + 1}`"
                  :max="`${goodsInfo.rentalTermMax}`"
                  v-model="scope.row.breakTermMax"
                  style="width: 64px"
                  @blur="numberBlur(scope.row, Number.parseInt(scope.row.breakTermMin || 0, 10) + 1, goodsInfo.rentalTermMax, 'breakTermMax')"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('crm_step_manage_falsify_dialog.jin_e')" width="260">
              <template slot-scope="scope">
                <custom-select
                  :disabled="model.type === 'watch'"
                  style="display: inline-block; width: 100px; margin-right: 2px"
                  v-model="scope.row.feeMode"
                  code="rms_sku_break_fee_mode"
                  :isDefault="true"
                  :clearable="false"
                ></custom-select>
                <el-input :disabled="model.type === 'watch'" type="number" :min="0" v-model="scope.row.feeValue" :placeholder="$t('Common.com_please_input')" style="width: calc(100% - 102px)"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('Common.com_remark')">
              <template slot-scope="scope">
                <el-input :disabled="model.type === 'watch'" v-model="scope.row.breakDesc" style="width: 100%"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('Common.com_handle')" width="90px" v-if="model.type !== 'watch'">
              <template slot-scope="scope">
                <el-button v-if="scope.$index == 0" type="primary" @click="addSymbol('breakDuringPeriodList')">
                  <!-- <i class="icon icon-add"></i> -->
                  {{ $t('Common.com_added') }}
                </el-button>
                <el-button v-else type="warning" @click="delSymbol('breakDuringPeriodList', scope.$index)">
                  <!-- <i class="icon icon-shanchu"></i> -->
                  {{ $t('Common.com_delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="footer" v-if="model.type !== 'watch'">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="confirm()">{{ $t('Common.com_save') }}</el-button>
        <el-button type="primary" @click="confirm(true)">{{ $t('crm_step_manage_falsify_dialog.tong_yi_she_zhi') }}</el-button>
      </div>
      <div class="footer" v-if="model.type === 'watch'">
        <el-button type="primary" @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      </div>
    </div>
  </custom-draw>
</template>

<script>
import apis from '@/utils/apis';
import customTab from '@/components/customTab';
import dialogMixins from '@/mixins/dialog_mixins.js';

const overdueItem = {
  feeMode: '1',
  feeValue: '',
  overdueDesc: '',
  rentalOverdueId: '',
  termNum: '',
  triggerDays: '',
};
const shortTermRentalItem = {
  breakDesc: '',
  breakTermMax: '',
  breakTermMin: '',
  feeMode: '1',
  feeValue: '',
  rentalBreakId: '',
};
const breakDuringPeriodItem = {
  breakDesc: '',
  breakTermMax: '',
  breakTermMin: '',
  feeMode: '1',
  feeValue: '',
  rentalBreakId: '',
};

export default {
  mixins: [dialogMixins],
  components: { customTab },
  data() {
    return {
      breakAction: '',
      goodsInfo: {},
      tabList: [],
      tab: '',
      tabForm: {
        goodsId: '',
        goodsSkuId: '',
      },
      form: {
        overdueList: [{ ...overdueItem }],
        shortTermRentalList: [{ ...shortTermRentalItem }],
        breakDuringPeriodList: [{ ...breakDuringPeriodItem }],
      },
    };
  },
  mounted() {
    this.goodsInfo = this.model.data.row;
    this.getDictionary('rms_sku_break_action', (dic) => {
      if (this.goodsInfo.goodsSkuOwner === 'HQ') {
        this.tabList = dic.rms_sku_break_action.filter((t) => t.code === 'hq_2_sc' || t.code === 'cs_2_hq').map((t) => ({ name: t.name, value: t.code }));
      } else if (this.goodsInfo.goodsSkuOwner.indexOf('HQ') !== -1) {
        this.tabList = dic.rms_sku_break_action.map((t) => ({ name: t.name, value: t.code }));
      } else {
        this.tabList = dic.rms_sku_break_action.filter((t) => t.code !== 'hq_2_sc' && t.code !== 'cs_2_hq').map((t) => ({ name: t.name, value: t.code }));
      }
      this.tab = this.tabList[0]['value'];
      this.getGoodsInfo();
    });
  },
  methods: {
    numberBlur: function (row, min, max, key) {
      if (!row[key]) {
        return;
      }
      if (Number.parseInt(row[key], 10) < Number.parseInt(min, 10)) {
        row[key] = Number.parseInt(min, 10) > Number.parseInt(max, 10) ? max : min;
      } else if (Number.parseInt(row[key], 10) > Number.parseInt(max, 10)) {
        row[key] = max;
      }
    },
    dataFilter: function (list) {
      return list.filter((t) => t.code !== this.tab);
    },
    onClear: function () {
      this.form = {
        overdueList: [{ ...overdueItem }],
        shortTermRentalList: [{ ...shortTermRentalItem }],
        breakDuringPeriodList: [{ ...breakDuringPeriodItem }],
      };
    },
    // 添加条件
    addSymbol: function (type) {
      if (type === 'overdueList') {
        this.form[type].push({ ...overdueItem });
      }
      if (type === 'shortTermRentalList') {
        this.form[type].push({ ...shortTermRentalItem });
      }
      if (type === 'breakDuringPeriodList') {
        this.form[type].push({ ...breakDuringPeriodItem });
      }
    },
    // 删除条件
    delSymbol: function (type, index) {
      this.form[type].splice(index, 1);
    },
    // 格式化数据（移除空数据）
    formatForm: function (tabKey) {
      if (!tabKey) {
        return;
      }
      const obj = {};
      obj.overdueList = this.form.overdueList.filter((t) => t.feeValue && t.triggerDays);
      obj.shortTermRentalList = this.form.shortTermRentalList.filter((t) => t.feeValue && t.breakTermMin && t.breakTermMax);
      obj.breakDuringPeriodList = this.form.breakDuringPeriodList.filter((t) => t.feeValue && t.breakTermMin && t.breakTermMax);
      this.tabForm[tabKey] = obj;
    },
    // 切换tab
    changeTab: function (oldKey, newKey) {
      this.breakAction = '';
      this.formatForm(oldKey);
      if (this.tabForm[newKey]) {
        const obj = this.tabForm[newKey];
        if (!obj.overdueList || obj.overdueList.length === 0) {
          obj.overdueList = [{ ...overdueItem }];
        }
        if (!obj.shortTermRentalList || obj.shortTermRentalList.length === 0) {
          obj.shortTermRentalList = [{ ...shortTermRentalItem }];
        }
        if (!obj.breakDuringPeriodList || obj.breakDuringPeriodList.length === 0) {
          obj.breakDuringPeriodList = [{ ...breakDuringPeriodItem }];
        }
        this.form = obj;
      } else {
        this.form = {
          overdueList: [{ ...overdueItem }],
          shortTermRentalList: [{ ...shortTermRentalItem }],
          breakDuringPeriodList: [{ ...breakDuringPeriodItem }],
        };
      }
    },
    // 获取详情
    getGoodsInfo: function () {
      this.$getJSON(apis.GoodsSkuGetSet, { goodsSkuId: this.goodsInfo.goodsSkuId }).then((res) => {
        this.tabForm = this.goodsInfo.isSetAll ? { goodsId: res.data.goodsId, goodsSkuId: res.data.goodsSkuId, productCode: res.data.productCode } : res.data;
        this.changeTab(null, this.tab);
      });
    },
    // 确认保存
    confirm: function (isSame) {
      this.formatForm(this.tab);
      if (Object.keys(this.tabForm).length === 2) {
        this.$message.error(this.$t('crm_step_manage_falsify_dialog.qtxwytkxx'));
        return;
      }
      if (isSame) {
        this.tabList.forEach((item) => {
          this.tabForm[item.value] = this.tabForm[this.tab];
        });
      }
      this.$postJSON(
        apis.GoodsSkuSet,
        Object.assign({}, this.tabForm, {
          goodsId: this.goodsInfo.isSetAll ? this.goodsInfo.goodsId : null,
          goodsSkuId: this.goodsInfo.isSetAll ? null : this.goodsInfo.goodsSkuId,
        })
      ).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
.el-drawer__body {
  height: 0;
}
.draw-body {
  display: flex;
  height: 100%;
  position: relative;
  .aside {
    width: 280px;
    padding: 0 16px;
    height: 100%;
    background: #f8f9fb;
    overflow-y: auto;
    h1 {
      line-height: 60px;
      height: 60px;
      color: #495057;
      font-size: 14px;
    }
    ul > li {
      line-height: 34px;
      height: 34px;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      color: #6c757d;
      box-shadow: 0px -1px 0px 0px #eef2f7;
    }
  }
  .draw-section {
    flex: 1;
    width: 0;
    height: calc(100% - 24px);
    overflow-y: auto;
    padding: 24px 24px 72px;
    position: relative;
    .sub-title {
      padding-left: 6px;
      font-size: 12px;
      font-weight: bold;
      line-height: 44px;
      color: #333333;
    }
  }
  .footer {
    position: absolute;
    box-shadow: 0px -1px 0px 0px rgba(238, 242, 248, 1);
    left: 280px;
    right: 0;
    bottom: 0;
    height: 60px;
    z-index: 999;
    padding-top: 16px;
    padding-left: 24px;
    background-color: #ffffff;
  }
}
</style>
